import mark from '../assets/rubikoo-mark.svg';

export function RubikooMark({ className = 'size-12' }: { className?: string }) {
  return <img src={mark} alt="" aria-hidden="true" className={`shrink-0 ${className}`} />;
}

export default function RubikooBrand() {
  return (
    <div className="flex items-center justify-center gap-3">
      <RubikooMark />
      <div>
        <p className="text-xl font-bold uppercase tracking-wide" style={{ color: 'var(--app-brand)' }}>Rubikoo</p>
        <p className="mt-1 text-xs" style={{ color: 'var(--app-text-muted)' }}>AI-powered event experiences</p>
      </div>
    </div>
  );
}
